


































































































































































































import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import { AcgnTitle, AcgnAuditStep, AcgnUpload } from '@acgn/herm/src/ui';
import { AcgnFormContent, AcgnFormTitle, AcgnProcedureEdit } from '@/components/';
import { namespace } from 'vuex-class';
import { complexClone } from '@acgn/herm/src/util/serialize';
import { Tree, Popover } from 'element-ui';
import { getComicUploadImageSts } from '@/api/ossClient';

const ComicAction = namespace('desk/comic').Action;
const StaffAction = namespace('desk/staff').Action;
const ComicGetter = namespace('desk/comic').Getter;
const CommGetter = namespace('desk/comm').Getter;
const AuthGetter = namespace('desk/auth').Getter;

interface ComicEditType { // 编辑结构类型
  name: string; // 名称
  target_type: number;
  target_num: any;
  target_period: number;
  status: number;
  update_rate: string;
  is_public: number;
  team_type: number;
  overdue_time: number;
  overdue_type: number;
}

// 组件申明
@Component({
  components: {
    AcgnTitle,
    AcgnAuditStep,
    AcgnFormContent,
    AcgnUpload,
    AcgnFormTitle,
    AcgnProcedureEdit,
    [Tree.name]: Tree,
    [Popover.name]: Popover
  }
})

/**
 * 项目编辑
 */
export default class ComicEdit extends Vue {

  @ComicAction private createComic: any; // 创建漫画
  @ComicAction private updateComic: any; // 编辑漫画
  @StaffAction private getDepartUserList: any; // 成员列表
  @ComicAction private getTemplate: any; // 流程模板
  @ComicAction private getProjectDetail: any; // 编辑详情
  @ComicGetter private loadings: any; // 漫画loading
  @CommGetter private attributeData: any; // 公共类型
  @AuthGetter private userInfo: any; // user信息

  private newworkflowList: any = [];
  private defaultDepart: any = [];
  private formData: ComicEditType = {
    name: '',
    target_type: 0,
    target_num: '',
    target_period: 1,
    status: 0,
    update_rate: '',
    is_public: 0,
    team_type: 0,
    overdue_time: 0,
    overdue_type: 0
  };
  private userList: any = [];
  private checkUserList: any[] = [];
  private checkAll: any[] = [];
  private isSort: any = false;
  private isEdit: any = false;
  private memberList: any = [];
  private createdId: any = '';

  private uploadPics: any = { // 图片上传
    shareImg: []
  };

  private uploadLoading: any = { // 图片上传状态
    shareImg: false
  };
  private imgOpts: any = { // 图片上传配置
    shareImg: null
  };
  private workflowList: any = [];

  // 目标周期
  private get weeklist() {
    if (this.attributeData.other_type) {
      return this.attributeData.other_type[4];
    }
  }

  // 目标类型
  private get typelist() {
    if (this.attributeData.other_type) {
      return this.attributeData.other_type[5];
    }
  }

  // 项目公开性
  private get publiclist() {
    if (this.attributeData.other_type) {
      return this.attributeData.other_type[6];
    }
  }

  // 过滤小数点
  private handerInput(e: any) {
    if (e.key === '.' && this.formData.target_type !== 3) {
      e.returnValue = false;
    }
  }

  // 项目状态
  private get prostadiusList() {
    if (this.attributeData.other_type) {
      return this.attributeData.other_type[7];
    }
  }

  // 逾期审批时间
  private get timeunitlist() {
    if (this.attributeData.other_type) {
      return this.attributeData.other_type[8];
    }
  }

  // 验证项目成员
  private validUserList(rule: any, value: any, callback: any) {
    if (this.checkUserList.length <= 0) {
      callback(new Error('请选择项目成员!'));
    } else {
      callback();
    }
  }

  // 获取表单验证规则
  private get rules() {
    const rules = {
      name: [
        { required: true, message: '标题不可为空', trigger: 'blur' }
      ],
      target_num: [
        { required: true, message: '请填写目标数', trigger: 'blur' }
      ],
      checkUserList: [
        { required: true, validator: this.validUserList, trigger: 'none' }
      ],
      overdue_time: [
        { required: true, message: '请输入提交画稿时间', trigger: 'blur' }
      ]
    };

    return rules;
  }

  // 获取图片地址
  private getImageAddress(arr: any) {
    this.uploadPics.shareImg = arr;
  }

  // 获取新的排序值
  private getNewWork(data: any) {
    this.newworkflowList = data;
  }

  // 获取成员列表
  private async userOperate() {
    const { result } = await this.getDepartUserList();
    this.userList = complexClone(result);
    this.userList.map((i: any) => {
      i.uid = i.id;
      this.defaultDepart.push(i.uid);
    });
    this.joinUserList(this.userList);
    // this.userList.map((i: any) => {
    //   i.label = `${i.name}`;
    //   i.children = [ ...i.children, ...i.users ];
    //   if (i.children.length <= 0) {
    //     i.disabled = true;
    //   }
    //   i.children.map((j: any) => {
    //     j.label = `${j.name} (${j.position})`;
    //     j.id = j.uid;
    //     j.parentNode = i.dept_name;
    //   });
    // });
  }

  private joinUserList(userlist: any) {
    for (const i of userlist as any) {
      i.label = i.name;
      if (i.children.length > 0) {
        this.joinUserList(i.children);
      }
      i.children.map((j: any) => {
        j.uid = j.id;
      });
      i.users.map((j: any) => {
        j.label = j.name;
        j.isuser = true;
        j.uid = i.id * 10 + j.id;
      });
      i.children = [ ...i.children, ...i.users ];
    }
  }

  // 流程设置
  private async getFlowList() {
    const { result } = await this.getTemplate({project_type: 1});
    this.workflowList = result;
    this.newworkflowList = result;
  }

  private setUserList(userlist: any) {
    for (const i of userlist as any) {
      if (i.children && i.children.length > 0) {
        this.setUserList(i.children);
      }
      if (this.memberList.length === 0) {
        if (this.userInfo.id === i.id) {
          i.disabled = true;
          this.checkAll.push(i);
        }
      } else {
        if (this.memberList.includes(i.id)) {
          if (this.createdId === i.id) {
            i.disabled = true;
          }
          this.checkAll.push(i);
        }
      }
    }
  }

  // 获取编辑详情
  private async editDetail(id: any) {
    const { result } = await this.getProjectDetail({project_id: id});
    this.formData = { ...result, project_id: id};
    this.workflowList = result.templates;
    this.newworkflowList = result.templates;
    // 成员赋值
    this.memberList = result.members;
    this.createdId = result.create_user_id;
    this.setUserList(this.userList);
    // 获取项目图
    if (result.image) {
      this.uploadPics.shareImg.push({ url: result.image });
    }
    ((this.$refs.multipleTable as any).setCheckedNodes(this.checkAll));
    this.getuserList();
  }

  private async created() {
    this.imgOpts.shareImg = {
      action: getComicUploadImageSts, filename: `oa_project_images/icon_${+new Date()}.jpg`, handle: true
    };
    const { id } = this.$route.params;
    await this.userOperate();
    if (id) {
      this.isEdit = true;
      this.editDetail(id);
    } else {
      this.getFlowList();
      this.setUserList(this.userList);
      (this.$refs.multipleTable as any).setCheckedNodes(this.checkAll);
      this.getuserList();
    }
    // this.getProjectDetail();
  }

  // 保存
  private submit() {
    (this.$refs.form as any).validate(async (valid: boolean) => {
      if (!valid) {
        this.$message.warning(this.$language.formValidateError);
        return;
      }
      if (this.formData.overdue_type === 0 && this.formData.overdue_time <= 0) {
        this.$message.warning('请填写提交画稿时间');
        return;
      }
      try {
        const postData: any = complexClone(this.formData);
        postData.members = [];
        this.checkUserList.map((i: any) => {
            postData.members.push(i.id);
        });
        this.newworkflowList.map((i: any, j: any) => {
          i.orders = j + 1;
          if (i.process_code === '' || i.template_name === '' ) {
            throw new Error('请确保输入环节名与审批流URL');
          }
        });
        postData.templates = this.newworkflowList;
        if (this.uploadPics.shareImg.length > 0) {
          postData.image = this.uploadPics.shareImg[0].url;
        }
        const isCreate: boolean = !postData.id;
        if (postData.templates.length <= 0) {
          this.$message.warning('请添加流程审批');
          return;
        }
        if (isCreate) { // 如果是新增
          const res = await this.createComic(postData);
          this.$message.success('创建成功');
          this.$router.back();
        } else {
          await this.updateComic(postData);
          this.$message.success('更新成功');
          this.$router.back();
        }
      } catch (ex) {
        if (ex.message) {
          this.$message.error(ex.message);
        } else {
          this.$message.error(this.$language.error);
        }
      }
    });
  }

  // 上传
  private handleAvatarSuccess() {}

  // 上传前验证
  private beforeAvatarUpload() {}

  // 选中组织架构
  private getuserList() {
    const data = ((this.$refs.multipleTable as any).getCheckedNodes(true));
    this.checkAll = data.filter((item: any) => item.isuser);
    const chatList = this.checkAll;
    const hash: any = {};
    this.checkUserList = chatList.reduce( (item: any, next: any) => {
      if (!hash[next.id]) {
        hash[next.id] = true;
        item.push(next);
      }
      return item;
    }, []);
  }

  // 删除成员
  private delUser(id: any) {
    if (this.checkAll.length > 0) {
      for (let i = this.checkAll.length - 1; i >= 0; i--) {
        if (this.checkAll[i].id === id) {
          this.checkAll.splice(i, 1);
        }
      }
    }
    ((this.$refs.multipleTable as any).setCheckedNodes(this.checkAll));
    this.getuserList();
  }

  // 返回列表
  private goBack() {
    // this.$confirm(`页面信息还未保存，确定离开吗?`, '提示').then(async () => {
    this.$router.back();
    // }).catch((ex) => { });
  }

  private getSort() {
    this.isSort = !this.isSort;
  }
}
